'use client'

import {
  Area,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Line,
  ComposedChart,
} from 'recharts'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
  type ChartData,
} from './chart'
import { toDate } from '../../lib'

export type ChartMixedConfig = {
  stroke?: string
  fill?: string
  fillOpacity?: number
}

export function ChartMixed({
  config,
  areaConfig,
  data,
  hideXAxis = false,
  hideYAxis = false,
  language,
  yAxisRange,
}: {
  config: ChartConfig
  data: ChartData[]
  areaConfig: ChartMixedConfig
  hideXAxis?: boolean
  hideYAxis?: boolean
  language?: string
  yAxisRange?: { min: number; max: number }
}) {
  return (
    <ChartContainer config={config}>
      <ResponsiveContainer>
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray='3 3' />
          <defs>
            <linearGradient id='colorUv' x1='0' y1='0' x2='0' y2='1'>
              <stop offset='0%' stopColor='#40286F' stopOpacity={1} />
              <stop offset='100%' stopColor='#40286F' stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey='name'
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) => toDate(new Date(value), language)}
            hide={hideXAxis}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) => value.toLocaleString()}
            hide={hideYAxis}
            domain={
              yAxisRange
                ? [yAxisRange.min, yAxisRange.max]
                : [
                    () => Math.min(...data.map((d) => d.value)),
                    (dataMax: number) => dataMax,
                  ]
            }
          />
          <ChartTooltip content={<ChartTooltipContent />} />
          <Line
            type='linear'
            dataKey='value2'
            stroke={areaConfig.stroke}
            fill={areaConfig.fill}
            fillOpacity={areaConfig.fillOpacity}
            strokeDasharray='6 4'
            dot={false}
          />
          <Area
            type='linear'
            dataKey='value'
            stroke='#40286F'
            strokeWidth={3}
            fill='url(#colorUv)'
            fillOpacity={areaConfig.fillOpacity}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartContainer>
  )
}
